<template>
<div :style="columnMargin" class="ad-four-prod">
  <div class="ad-swiper">
    <van-swipe :autoplay="item.autoplay" :show-indicators="false">
      <van-swipe-item @click="doLocationHref(swipeItem)" v-for="(swipeItem,swipeIndex) in item.adList" :key="swipeIndex">
        <img class="swiper-img" :src="swipeItem.imgUrl" alt="">
      </van-swipe-item>
    </van-swipe>
  </div>
  <div class="four-prod flex-1">
    <div @click="toProdDetail(prodItem)" v-for="(prodItem,prodIndex) in item.prodList" :class="['prod-one',{'margin-top-1': prodIndex > 1}]" :key="prodIndex">
      <img class="prod-img" :src="prodItem.imgUrl" alt="">
      <div class="prod-name">{{prodItem.prodName}}</div>
      <div class="prod-price-bar">
        <div class="flex-1 col-1"><span style="color:#F72D17">¥<span class="prod-price">{{prodItem.prodPrice}}</span></span><span v-if="0" class="prod-old-price">{{prodItem.originPrice}}</span></div>
        <div @click.stop="addShopCart(prodItem)" class="prod-cart"></div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios';
export default { 
  name: 'AdFourProd',
  data() {
    return {
      active: 0,
      addShopCartLock: {}
    }
  },
  props: {
    item: Object,
  },
  components: {
  },
  created() {
  },
  mounted() {
  },
  watch: {
  },
  computed: {
    columnMargin(){
      var obj = {}
      if(this.item.marginObj){
        obj={
          'margin-top': this.item.marginObj.top,
          'margin-bottom': this.item.marginObj.bottom
        }
      }
			return obj
    }
  },
  methods: {
    doLocationHref(obj){
      var self = this
      this.$store.commit('doTrack',{
        href: obj.adHrefUrl,
        columnDefineId: self.item.columnDefineId,
        ccId: obj.ccId,
        adId: obj.adId,
        adName: obj.adName,
        idType: 'adId'
      });
      window.location.href = obj.adHrefUrl
    },
    toProdDetail(obj){
      var self = this
      var url = '/client/cpd_' + obj.prodId + '.jhtml'
      obj.prodUrl && (url = obj.prodUrl);
      this.$store.commit('doTrack',{
        href: url,
        columnDefineId: self.item.columnDefineId,
        ccId: obj.ccId,
        adId: obj.prodId,
        adName: obj.prodName,
        idType: 'prodId'
      });
      window.location.href = url
    },
    addShopCart(obj){
      var self = this
      if(self.addShopCartLock[obj.prodId]){
        return
      }
      var fqzxStatus = obj.productLabels && obj.productLabels.length && obj.productLabels.findIndex(o=>o.key=='FQZX') > -1;
      if(obj.isSku && obj.isSku == '0' && !fqzxStatus){
        var params = {
          "addTime": new Date().getTime(),
          "shopCar.productId": obj.prodId,
          "shopCar.productName": obj.name,
          "shopCar.productAmt": 1,
          "shopCar.productImage": obj.imgUrl,
          "shopCar.productPrice": obj.prodPrice,
          "shopCar.productType": '0',
          "shopCar.channelType": '1',
          "shopCar.buyDelivery": '01',
          "shopCar.payMode": obj.paymentId + '_null',
          "shopCar.merchantId": obj.merchantId,
          "shopCar.productCategoryId": obj.catId
        }
        self.addShopCartLock[obj.prodId] = true
        axios.get('/shoppingcart/addShopCarJS.jhtml', { params: params }).then(function(res){
          self.addShopCartLock[obj.prodId] = false
          if (res.data.resultCode == "0") {
            self.$store.commit('setPublicToast',{
              show: true,
              type: 'addShopcart',
              text: '添加成功，在购物车等亲~'
            });
            clientTools.updateBottomNavShopcarSum()
            // self.$toast('添加购物车成功');
          } else {
            self.$toast(res.data.msg);
          }
        })
        return
      }

      var url = '/client/cpd_' + obj.prodId + '.jhtml'
      obj.prodUrl && (url = obj.prodUrl);
      window.location.href = url
    }
  }
}
</script>

<style scoped>
.ad-four-prod{
  margin-top: 10px;
  margin-left: 15px;
  width: 345px;
  height: 291px;
  border-radius: 6px;
  display: flex;
  background: #fff;
  overflow: hidden;
}
.ad-swiper{
  width: 148px;
  height: 291px;
}
.swiper-img{
  width: 148px;
  height: 291px;
  display: block
}
.four-prod{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.prod-one{
  width: 98px;
  height: 145px;
  background-image: linear-gradient(180deg, #FFFFFF 21%, #FFDDDD 100%);
}
.prod-img{
  width: 88px;
  height: 88px;
  display: block;
  object-fit: contain;
  margin-left: 5px;
  margin-top: 7px;
  margin-bottom: 3px
}
.prod-name{
  width: 88px;
  height: 26px;
  line-height: 26px;
  padding: 0 5px;
  font-size: 12px;
  color: #333;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  white-space: normal;
  text-overflow: ellipsis;
  word-break: break-all;
}
.prod-price-bar{
  width: 84px;
  padding: 0 7px;
  display: flex;
  align-items: center;
  font-size: 10px;
  color: #999;
}
.prod-price{
  margin-left: 0.5px;
  font-size: 14px
}
.prod-old-price{
  color: #999;
  text-decoration: line-through;
  margin-left: 2px
}
.prod-cart{
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #FFF4F4 url(./assets/cart_icon.png) no-repeat center;
  background-size: 100%
}
.margin-top-1{
  margin-top: 1px
}
</style>